import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SetupAccountForm from "../../components/auth/SetupAccountForm";

export default function SetupAccount() {
  return (
    <>
      <PageMeta
        title="Setup Account - Netsights"
        description="Set up your Netsights account and create a new password to continue monitoring your store performance."
      />
      <AuthLayout>
        <SetupAccountForm />
      </AuthLayout>
    </>
  );
}

